import { render, staticRenderFns } from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=template&id=e226bee0"
import script from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteParametriVitaliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports